import { Component, Input } from "@angular/core";
import { DIGITAL_MENU_CONSTANTS } from "@src/components/ib-MmB-gastronomic-proposal/constants/gastronomic-proposal-constants";
import { Item } from "@src/components/ib-MmB-gastronomic-proposal/models/digital-menu.model";
import { downgradeToAJSComponent } from 'ib-web-commons/utils';

@Component({
    selector: 'ib-digital-menu-item',
    templateUrl: './ib-digital-menu-item.component.html',
})

export class IbDigitalMenuItemComponent {

    alergensIconUrl = DIGITAL_MENU_CONSTANTS.ALERGENS_ICONS_URL;
    @Input() item!: Item;
    @Input() separator: boolean = true;

    constructor() { }


    showAllergenDisclamer() {
        return this.item.allergens.length === 1 && (this.item.allergens[0].code === 'LAB' || this.item.allergens[0].code === 'UNK');
    }
}

downgradeToAJSComponent('ibDigitalMenuItem', {
    component: IbDigitalMenuItemComponent,
    inputs: ['item']
}, 'ib-MmB-gastronomic-proposal-module');
